import { render, staticRenderFns } from "./IconRoundTick.vue?vue&type=template&id=3c525c0a&scoped=true&"
import script from "./IconRoundTick.vue?vue&type=script&lang=js&"
export * from "./IconRoundTick.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c525c0a",
  null
  
)

export default component.exports